import { User, Plus } from "lucide-react";
import { Button } from "@/components/ui/button";
import { ContactCard } from "./contacts/ContactCard";
import { ContactListItem } from "./contacts/ContactListItem";
import { Contact } from "./contacts/types";
import { useTranslation } from "react-i18next";

interface ContactsListProps {
  contacts: Contact[];
  loading: boolean;
  viewMode: 'list' | 'card';
  companyId: string;
  onAddContact: () => void;
  onViewContact: (contact: Contact) => void;
  onEditContact: (contact: Contact) => void;
}

export const ContactsList = ({ 
  contacts, 
  loading, 
  viewMode,
  companyId,
  onAddContact,
  onViewContact,
  onEditContact
}: ContactsListProps) => {
  const { t } = useTranslation();
  if (loading) {
    return (
      <div className="animate-pulse space-y-4">
        {[1, 2, 3].map((i) => (
          <div key={i} className="h-20 bg-gray-200 rounded-lg"></div>
        ))}
      </div>
    );
  }
  
  if (contacts.length === 0) {
    return (
      <div className="text-center py-8 border rounded-lg">
        <User className="h-8 w-8 text-gray-400 mx-auto" />
        <p className="mt-2 text-gray-500">{t("contacts.empty")}</p>
        <Button variant="outline" className="mt-3" onClick={onAddContact}>
          <Plus className="h-4 w-4 mr-2" />
          {t("contacts.add")}
        </Button>
      </div>
    );
  }
  
  return (
    <div className={viewMode === 'card' ? "grid grid-cols-1 md:grid-cols-2 gap-4" : "space-y-3"}>
      {contacts.map((contact) => (
        viewMode === 'card' ? (
          <ContactCard 
            key={contact.id} 
            contact={contact} 
            onView={onViewContact} 
            onEdit={onEditContact} 
          />
        ) : (
          <ContactListItem 
            key={contact.id} 
            contact={contact} 
            onView={onViewContact} 
            onEdit={onEditContact} 
          />
        )
      ))}
    </div>
  );
};
